import { URL_SERVICE } from "../shared/constants/api-constants";
import { axiosInstance } from '../shared/services/axios-instance';

class CaretakersServices {
    //allows to redeem a module
    static redeemModule(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/caregiver-course/api/v1/redeem-module", payload, config).then(resp => resp.data)
    }
    //allows to query a module´s state
    static validateModuleState(payload, config) {
        return axiosInstance.get(URL_SERVICE + "/caregiver-course/api/v1/validate-module" + payload, config).then(resp => resp.data)
    }
    //allows to query a module´s state
    static getModuleState({courseId, moduleNumber}) {
        return axiosInstance.get(URL_SERVICE + `/caregiver-course/api/v1/modulo-status?courseId=${courseId}&moduleNumber=${moduleNumber}`).then(resp => resp.data)
    }
    //allows to query a module´s self appraisal questions
    static autoevaluationInfo(payload, config) {
        return axiosInstance.get(URL_SERVICE + "/caregiver-course/api/v1/autoevaluation-info" + payload, config).then(resp => resp.data)
    }
    //allows to redeem a module
    static saveAutoevaluation(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/caregiver-course/api/v1/save-autoevaluation", payload, config).then(resp => resp.data)
    }
    //allows to check if the user already finished a course
    static courseCompletion(payload, config) {
        return axiosInstance.get(URL_SERVICE + "/caregiver-course/api/v1/course-completion" + payload, config).then(resp => resp.data)
    }
    //allows to download the diploma
    static generateDiploma(payload, config) {
        return axiosInstance.get(URL_SERVICE + "/caregiver-course/api/v1/generate-diploma" + payload, config).then(resp => resp.data)
    }
}

export default CaretakersServices;